import {
    CaseWorkflowSections,
    CaseWorkflowSettingsTypes,
    Workflow,
    WorkflowParticipant,
    WorkflowTargets
} from '../../../shared/models/workflow';
import { BaseHttpService, Create, Delete, UriBuilderParams } from '../base/base-http.service';
import { BackendUriUnits } from '../base/backend-uri-units';
import { Observable } from 'rxjs';
import { DrQueryParams } from '../base/base-service-with-bundle.service';
import { HttpServiceBundle } from '../base/http-service-bundle.service';
import { Injectable } from '@angular/core';


export class WorkflowParticipantUriBuilderParams extends UriBuilderParams<WorkflowParticipant> {
    private readonly _target: string;
    private readonly _workflow: Workflow | string;

    get target() {
        return this._target;
    }

    get workflow() {
        return this._workflow;
    }

    constructor(target: WorkflowTargets, workflow: Workflow | string, workflowParticipant: WorkflowParticipant | string) {
        super(workflowParticipant);
        this._target = target;
        this._workflow = workflow;
    }

    public buildUri(): string {
        let uri = `/${BackendUriUnits.WORKFLOW}/${BackendUriUnits.WORKFLOWS}/${this.target}/${this.getParamId(this.workflow)}/${CaseWorkflowSections.DEFAULTS}`;
        uri += this.simpleUriBuild(CaseWorkflowSettingsTypes.PARTICIPANTS);
        return uri;
    }

    public buildTypeUri(): string {
        let uri = `/${BackendUriUnits.WORKFLOW}/${BackendUriUnits.WORKFLOWS}/${this.target}/${this.getParamId(this.workflow)}/${CaseWorkflowSettingsTypes.PARTICIPANTS}/${BackendUriUnits.TYPES}`;
        return uri;
    }
}


@Injectable({
    providedIn: 'root'
})
export class WorkflowParticipantsService extends BaseHttpService<WorkflowParticipant, WorkflowParticipantUriBuilderParams>
                                         implements Create<WorkflowParticipant, WorkflowParticipantUriBuilderParams>,
                                                    Delete<WorkflowParticipant, WorkflowParticipantUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(WorkflowParticipant, httpServiceBundle);
        // Setting a new uri because this is not an SMP call
        this.uri = this.uri.replace('/smp', '');
    }

    public create(uriParams: WorkflowParticipantUriBuilderParams, workflowParticipant: WorkflowParticipant, params?: DrQueryParams): Observable<WorkflowParticipant> {
        return this.createBase(uriParams, workflowParticipant, params);
    }

    public delete(uriParams: WorkflowParticipantUriBuilderParams): Observable<boolean> {
        return this.deleteBase(uriParams);
    }

}
